import React from "react";
import { Paths } from "../constants/UrlConstants";

export default {
  Heading: <h2>Specialist Appointment Booking Service</h2>,
  Description: <p>Your booked appointments are listed below.</p>,
  ViewDetailsLabel: "View details",
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    HelpSet: [
      {
        Question: "Is the Specialist Appointment Booking Service included as part of my plan?",
        Answer: (
          <p>
            Yes, we can offer the Specialist Appointment Booking Service providing you have an open
            referral. We can then find you a Specialist and even book the
            appointment for you.
          </p>
        )
      },
      {
        Question: "How do I book a Specialist Appointment",
        Answer: (
          <p>
            To book a Specialist Appointment ask your GP for an open referral
            (the GP doesn't give you a Specialist name just the specialism).
            Then give us a call and we'll book you an appointment, at a time and
            place that suits you. Alternatively we can give you a choice of up
            to three appropriate Specialists and you can contact them when you
            want to.
          </p>
        )
      },
      
      {
        Question: "What do I do if I need to change my appointment?",
        Answer: (
          <React.Fragment>
            <p>
              If you need to cancel or re-book your appointment, please contact
              your specialist directly on the phone number shown on the
              appointment details. They may charge a cancellation fee if you
              give less than 24 hours notice for this.
            </p>
            <p>
              Should you wish to see a different specialist, or need treatment
              at an alternative hospital to the one we've booked for you, please
              call Specialist Appointment Booking Service on 0800 092 9668. We will then
              confirm whether your plan covers treatment with this alternative
              healthcare provider.
            </p>
          </React.Fragment>
        )
      }
    ]
  },
  AppointmentsBackButtonLabel: "Specialist appointment booking service",
  AppointmentDetails: {
    Header: <h1>Appointment details</h1>,
    Body: (
      <p>
        All the information you’ll need about your appointment can be found
        here.
      </p>
    ),
    PrintDetailsButton: "Print details",
    PrintDetailDescription: "Need to print these details?",
    AppointmentDescription: "What are the details of my appointment?",
    HelpSetQuestion: "What do I do if I need to change my appointment?",
    HelpSetAnswer: (props, params) => (
      <React.Fragment>
        <p>
          If you need to cancel or reschedule your appointment, please notify the hospital directly, unless advised otherwise.
          They may charge a cancellation fee if you give less than 24 hours notice for this.
        </p>
        <p>
          Should you wish to see a different specialist, or need treatment at an
          alternative hospital to the one we've booked for you, please call Specialist Appointment Booking Service 
          on <strong>0800 092 9668</strong>. We will then
          confirm whether your plan covers treatment with this alternative
          healthcare provider.
        </p>
      </React.Fragment>
    ),
    AppointmentType: "Appointment type",
    Date: "Date",
    Time: "Time",
    ClaimNumber: "Claim number",
    Specialist: "Specialist",
    HospitalAddress: "Hospital address",
    HospitalTelephoneNumber: "Hospital telephone number",
    BookingRefNumber: "Booking reference number",
    AdditionalInformation: "Additional information",
    WhatToTakeWithYou: "What to take with you",
    WhatToTakeDescription:
      "Please take the following with you to your appointment.",
    YourClaimNumber: "Your claim number: ",
    GPLetter: "Your GP referral letter",
    DebitCard: "Your debit or credit card",
    AfterAppointHeading: "After your appointment",
    HospitalName: "Hospital name",
    AfterAppointDescription: (
      <p>
        If the specialist suggests that you should have additional tests or
        treatment, please call us on <strong>0800 092 1787</strong> so that we
        can guide you further.
      </p>
    )
  }
};
